import React from 'react';
import QuestionLearnButton from '../full_mock_test/attempt/QuestionLearnButton';

// One-letter answer box — mirrors the paper format ("write a letter A–H next
// to each person") instead of tapping a letter from a row of circles.
const KetLetterInput = ({ question, letters, answer, onSelect, showHint, isReviewMode, isHydrated }) => {
  const isExample = question.points === 0;
  const isAnswerCorrect = question.is_correct === true || question.is_correct === 'true';
  const correctAnswer = question.accepted_answers && question.accepted_answers[0];

  const displayValue = isExample
    ? correctAnswer
    : (showHint || (isReviewMode && isAnswerCorrect))
      ? correctAnswer
      : (answer || '');

  const readOnly = isExample || isReviewMode || showHint || !isHydrated;
  const isWrong = isReviewMode && !isExample && !isAnswerCorrect;

  const handleChange = (e) => {
    const v = e.target.value.toUpperCase().slice(-1);
    if (v === '' || letters.includes(v)) onSelect(question.id, v);
  };

  return (
    <div className="flex items-center gap-2">
      <input
        type="text"
        value={displayValue || ''}
        onChange={handleChange}
        readOnly={readOnly}
        maxLength={2}
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        aria-label={`Đáp án (${letters[0]}–${letters[letters.length - 1]})`}
        placeholder={`${letters[0]}–${letters[letters.length - 1]}`}
        className={`w-14 h-11 text-center rounded-xl border-2 font-display font-black text-lg uppercase transition-all outline-none placeholder:text-slate-300 placeholder:text-sm placeholder:font-bold
          ${isExample || (showHint && !isReviewMode) ? 'bg-amber-50 border-amber-400 text-amber-600' : ''}
          ${isReviewMode && isAnswerCorrect ? 'bg-green-50 border-green-500 text-green-600' : ''}
          ${isWrong ? 'bg-red-50 border-red-400 text-red-500' : ''}
          ${!isExample && !isReviewMode && !showHint ? 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-600 text-slate-700 dark:text-slate-200 focus:border-primary-blue' : ''}
          ${readOnly ? 'cursor-default' : ''}
        `}
      />
      {isWrong && (
        <span className="font-bold text-sm text-green-600 whitespace-nowrap">→ {correctAnswer}</span>
      )}
      {isReviewMode && !isExample && (isAnswerCorrect
        ? <span className="correct-checkmark">✓</span>
        : <span className="incorrect-checkmark">✗</span>
      )}
      {isReviewMode && !isExample && <QuestionLearnButton question={question} />}
    </div>
  );
};

export default KetLetterInput;
